import { combineReducers, configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage';
import {persistReducer, persistStore} from "redux-persist";
import modalManagerSlice from "../modalManagerSlice";
import stepperSlice from "../stepperSlice";
import {createLogger} from "redux-logger";
import kioskSlice from "./kioskSlice";
import uuidSlice from "./uuidSlice";
import projectSlice from "../projectSlice";

const logger = createLogger();

const reducer = combineReducers({
    modalManager: modalManagerSlice,
    stepper: stepperSlice,
    kiosk: kioskSlice,
    uuid: uuidSlice,
    project: projectSlice
})

const persistConfig = {
    key: 'kiosk-root',
    storage: storage,
    whitelist: ['uuid'],
    version: 10,
}

const persistedReducer = persistReducer(persistConfig, reducer);

export const kioskStore = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
    // .concat(process.env.NODE_ENV !== 'production' ? logger : null),
    devTools: process.env.NODE_ENV !== 'production',
    reducer: persistedReducer
})

export const kioskPersistor = persistStore(kioskStore);
